import React from 'react';
import './styles/Taskbar.css'; // Import the CSS for styling
import { getIndexedTitle } from './includes/utils';

const Taskbar = ({ minimizedWindows, onRestore, allWindows }) => {
	return (
		<div className="taskbar">
			{minimizedWindows.map((program, index) => (
				<div
					key={index}
					className="program-icon"
					style={{ width: '100px', padding: '10px', textAlign: 'center' }}
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onRestore(program)
					}
					}
					onDoubleClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						onRestore(program)
					} // Handle double click to restore window
					}
					 // Handle icon click to open a window
				>
					<div style={{ fontSize: '2em' }}>{program.icon}</div> {/* Display the icon */}
					<div>{getIndexedTitle(program.title, program.progName, allWindows || [], program.windowId)}</div> {/* Display the program name with index */}
				</div>
			))}
		</div>
	);
};

export default Taskbar;
